import { TranslateService } from '@ngx-translate/core';

/**
 * Column-key helpers for grid views composed around <app-data-grid>.
 *
 * The view keeps its `i18nViewName = '<literal>'` class field: the i18n usage
 * scanner (scripts/i18n-scan.mjs, rule K4) reads that declaration to register
 * the view's '<name>.grid.column.*' keys as used.
 */

/** Full dotted column key: gridColumnKey('role-list', 'name') -> 'role-list.grid.column.name'. */
export function gridColumnKey(viewName: string, key: string): string {
  return `${viewName}.grid.column.${key}`;
}

/** Translated column header for column defs: headerName: gridColumnHeader(translate, viewName, 'name'). */
export function gridColumnHeader(
  translateService: TranslateService,
  viewName: string,
  key: string,
): string {
  return translateService.instant(gridColumnKey(viewName, key));
}
